"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oAuthPermissions = exports.isAdministerRole = exports.isWriteRole = exports.isReadWritePermission = exports.isReadPermission = exports.getAdministerPermission = exports.getWritePermission = exports.getReadWritePermission = exports.getReadPermission = exports.verbs = exports.resources = void 0;
var resources = {
  kiconectConfiguration: 'kiconnect.configuration',
  kiconnectClients: 'kiconnect.clients',
  kiconnectClientsService: 'kiconnect.clients.service',
  kiconnectClientsSystem: 'kiconnect.clients.system',
  kiconnectApis: 'kiconnect.apis',
  kiconnectPermissions: 'kiconnect.permissions',
  kiconnectRoles: 'kiconnect.roles',
  kiconnectUsers: 'kiconnect.users',
  kiconnectTenants: 'kiconnect.tenants'
};
exports.resources = resources;
var verbs = {
  read: 'read',
  write: 'write',
  readWrite: 'readwrite',
  administer: 'administer'
};
exports.verbs = verbs;

var getReadPermission = function getReadPermission(resource) {
  return "".concat(resource, ".").concat(verbs.read);
};

exports.getReadPermission = getReadPermission;

var getReadWritePermission = function getReadWritePermission(resource) {
  return "".concat(resource, ".").concat(verbs.readWrite);
};

exports.getReadWritePermission = getReadWritePermission;

var getWritePermission = function getWritePermission(resource) {
  return "".concat(resource, ".").concat(verbs.write);
};

exports.getWritePermission = getWritePermission;

var getAdministerPermission = function getAdministerPermission(resource) {
  return "".concat(resource, ".").concat(verbs.administer);
};

exports.getAdministerPermission = getAdministerPermission;

var isReadPermission = function isReadPermission(permission) {
  return permission && (permission.endsWith(verbs.read) || isReadWritePermission(permission));
};

exports.isReadPermission = isReadPermission;

var isReadWritePermission = function isReadWritePermission(permission) {
  return permission && permission.endsWith(verbs.readWrite);
};

exports.isReadWritePermission = isReadWritePermission;

var isWriteRole = function isWriteRole(permission) {
  return permission && (permission.endsWith(verbs.write) || isReadWritePermission(permission));
};

exports.isWriteRole = isWriteRole;

var isAdministerRole = function isAdministerRole(permission) {
  return permission && permission.endsWith(verbs.administer);
};

exports.isAdministerRole = isAdministerRole;
var oAuthPermissions = {
  kiconectConfigurationReadWrite: getReadWritePermission(resources.kiconectConfiguration),
  kiconnectClientsReadWrite: getReadWritePermission(resources.kiconnectClients),
  kiconnectClientsServiceReadWrite: getReadWritePermission(resources.kiconnectClientsService),
  kiconnectClientsSystemReadWrite: getReadWritePermission(resources.kiconnectClientsSystem),
  kiconnectApisReadWrite: getReadWritePermission(resources.kiconnectApis),
  kiconnectPermissionsRead: getReadPermission(resources.kiconnectPermissions),
  kiconnectRolesWrite: getWritePermission(resources.kiconnectRoles),
  kiconnectRolesRead: getReadPermission(resources.kiconnectRoles),
  kiconnectUsersWrite: getWritePermission(resources.kiconnectUsers),
  kiconnectUsersRead: getReadPermission(resources.kiconnectUsers),
  kiconnectTenantsWrite: getWritePermission(resources.kiconnectTenants),
  kiconnectTenantsRead: getReadPermission(resources.kiconnectTenants),
  kiconnectTenantsAdminister: getAdministerPermission(resources.kiconnectTenants)
};
exports.oAuthPermissions = oAuthPermissions;
//# sourceMappingURL=oauth-permissions.js.map